import React from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getShifts } from '../redux.actions';

const SelectShift = ({ getShifts, input: { value, onChange } }) => {
    const [shifts, setShifts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getShifts({
            handleSubmit: (data) => {
                setIsLoading(false);
                if (data && data.data) {
                    setShifts(
                        data.data.map((shift) => ({
                            name: shift.name,
                            value: shift.name
                        }))
                    );
                }
            }
        });
    }, [getShifts]);

    const selectedShift = shifts.find((s) => String(s.value) === String(value)) || null;

    return (
        <Autocomplete
            size='small'
            sx={{
                minWidth: 158,
                backgroundColor: theme => theme.palette.common.paper
            }}
            componentsProps={{
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                        }
                    }
                }
            }}
            options={shifts}
            getOptionLabel={(option) => option.name || ''}
            value={selectedShift}
            onChange={(event, newValue) => {
                onChange(newValue ? newValue.value : '');
            }}
            loading={isLoading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Shift'
                    placeholder='Select shift'
                    sx={{
                        '& .MuiInputBase-input': { fontSize: '12px' },
                        '& .MuiInputLabel-root': { fontSize: '12px' }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color='inherit'
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    getShifts: (payload) => dispatch(getShifts(payload))
});

export default connect(null, mapDispatchToProps)(SelectShift);
